// routesConfig.js
import React from 'react';
import AppHome from '../home/home';
import DashboardLoader from '../dashboards/dashboards';
import ChartLoader from '../charts/details_loader'
import ProfileLoader from '../profile/profile';
import SettingsLoader from '../settings/settings';
import AuthCallback from '../auth/callback';
import LoginLoader from '../auth/login';
import EstablishPage from '../auth/establish';

export const protectedRoutes = (mode, setMode) => [
  {
    path: '/home',
    element: <AppHome />,
  },
  {
    path: '/dashboard',
    element: <DashboardLoader />,
  },
  {
    path: '/dashboard/:id',
    element: <DashboardLoader />,
  },
  {
    path: '/chart/:id',
    element: <ChartLoader />,
  },
  {
    path: '/profile',
    element: <ProfileLoader />,
  },
  {
    path: '/settings',
    element: <SettingsLoader />,
    extraProps: { mode, setMode },
  },
];

export const publicRoutes = [
  {
    path: '/callback',
    element: <AuthCallback />,
  },
  {
    path: '/login',
    element: <LoginLoader />,
  },
  {
    path: '/',
    element: <EstablishPage />,
  },
];
